export const FORM_ID = {
  RELEASE_OF_INFO: 1,
  AUTHORIZATION: 2,
  PERSONAL_INFO: 3,
  RESIDENTIAL_ADDRESS: 4,
  BUSINESS_INFO: 5,
  BROKER_DEALER: 6,
  CCB: 7,
  ERRORS_OMISSIONS: 8,
  DIRECT_DEPOSIT: 9,
  REVIEW_SIGN_1: 10,
  REVIEW_SIGN_2: 11,
  PROFESSIONAL_DESIGNATION: 12,
  OTHER_BUSINESS: 13,
  RESIDENTIAL_HISTORY: 14,
  EDUCATION: 15,
  PERSONAL_INFO_ADDITIONAL_INFO: 16,
  EMPLOYMENT_HISTORY: 17,
  PERSONAL_SALES_RECORD: 18,
  CCB_INTRO: 19,
  CRIMINAL_DISCLOSURE: 20,
  REGULATORY_ACTION_DISCLOSURE: 21,
  CIVIL_JUDICIAL_DISCLOSURE: 22,
  CUSTOMER_COMPLAINT_DISCLOSURE: 23,
  TERMINATION_DISCLOSURE: 24,
  FINANCIAL_DISCLOSURE: 25,
  PERSONAL_SALES_RECORD_CHARTS: 26,
  CORPORATE_INFO: 27,
  CORPORATE_CCB: 28,
  CORPORATE_ERRORS_OMISSIONS: 29,
  CORPORATE_BUSINESS_ADDRESS: 30,
  CORPORATE_DIRECT_DEPOSIT: 31,
  MMLIS_INTRO: 32,
  MMLIS_PAY_TO_PLAY_1: 33,
  MMLIS_PAY_TO_PLAY_2: 34,
  MEMBER_CORPORATE_INFO: 35,
  MMLIS_OBA_CRIA: 36,
  PROFESSIONAL_DESIGNATION_CRIA:37,
  PERSONAL_INFO_COVER_ADVISOR: 38,
};

export const FORM_NAMES = {
  RELEASE_OF_INFO: "Release of Information",
  AUTHORIZATION: "Authorization to Work in the US",
  PERSONAL_INFO: "Personal Information",
  PERSONAL_INFO_ADDITIONAL_INFO: "Personal Information",
  PERSONAL_INFO_COVER_ADVISOR: "Personal Information",
  RESIDENTIAL_ADDRESS: "Residential Address",
  BUSINESS_INFO: "Business Information",
  BROKER_DEALER: "Broker Dealer Information",
  CCB: "Character, Credit, and Bonding",
  ERRORS_OMISSIONS: "Errors & Omissions (E&O) Coverage, Group Insurance",
  DIRECT_DEPOSIT: "Direct Deposit Information",
  REVIEW_SIGN_1: "Review & Sign",
  REVIEW_SIGN_2: "Review & Sign",
  PROFESSIONAL_DESIGNATION: "Education",
  OTHER_BUSINESS: "Other Business",
  RESIDENTIAL_HISTORY: "Residential History",
  EDUCATION: "Education",
  EMPLOYMENT_HISTORY: "Employment History",
  PERSONAL_SALES_RECORD: "Personal Sales Record",
  PERSONAL_SALES_RECORD_CHARTS: "Personal Sales Record",
  PERSONAL_PRODUCTION_RECORD: "Personal Production Record",
  CCB_INTRO: "Criminal Disclosure",
  CRIMINAL_DISCLOSURE: "Criminal Disclosure",
  REGULATORY_ACTION_DISCLOSURE: "Regulatory Action Disclosure",
  CIVIL_JUDICIAL_DISCLOSURE: "Civil Judicial Disclosure",
  CUSTOMER_COMPLAINT_DISCLOSURE: "Customer Complaint Disclosure",
  TERMINATION_DISCLOSURE: "Termination Disclosure",
  FINANCIAL_DISCLOSURE: "Financial Disclosure",
  CORPORATE_INFO: "Corporation Information",
  CORPORATE_CCB: "Corporation Character, Credit, and Bonding",
  CORPORATE_ERRORS_OMISSIONS:
    "Corporation Errors & Omissions (E&O) Coverage, Group Insurance",
  CORPORATE_BUSINESS_ADDRESS: "Corporation Business Information",
  CORPORATE_DIRECT_DEPOSIT: "Corporation Direct Deposit Information",
  MMLIS: "MMLIS",
  MMLIS_OBA_CRIA: "MMLIS",
  MMLIS_INTRO: "MMLIS",
  MMLIS_PAY_TO_PLAY_1: "MMLIS",
  MMLIS_PAY_TO_PLAY_2: "MMLIS",
  MEMBER_CORPORATE_INFO: "Corporation Information",
  PROFESSIONAL_DESIGNATION_CRIA: "Professional Registrations or Designations",
};
